
const QuestionTitle = () => {
    return (
        <div style={{ marginBottom: "5vh" }}>
            <div style={{ marginBottom: "3vh" }}>
                <span style={{ fontSize: "2rem", fontWeight: "700" }} >새로운 질문은</span> <br />
                <span style={{ fontSize: "2rem", fontWeight: "700" }}><span style={{ color: "#FF7A00" }}>Mat Zip</span>을 새롭게 해요!</span>
            </div>
        </div>
    )
}

export default QuestionTitle;